import React from 'react';
import { Box } from '@mui/material';
import './quantia.css';

/**
 * Cabecera de sección Quantia: pequeño label uppercase morado +
 * título grande Fira Sans 900 con palabra resaltada y descripción.
 *
 * Props:
 *  - label:        ej. "01 — Servicios" (uppercase, lime/morado)
 *  - title:        string del título principal
 *  - highlight:    fragmento del título que se pinta morado (split visual)
 *  - description:  texto de apoyo opcional
 *  - align:        'left' (default) | 'center'
 *  - sx:           sx adicional para el wrapper
 */
const SectionHeader = ({
  label,
  title,
  highlight,
  description,
  align = 'left',
  sx = {},
}) => {
  // Si highlight aparece dentro de title, partimos en tres trozos para colorear el del medio.
  const renderTitle = () => {
    if (!highlight || !title.includes(highlight)) {
      return <span>{title}</span>;
    }
    const idx = title.indexOf(highlight);
    return (
      <>
        <span>{title.slice(0, idx)}</span>
        <span className="qa-section-header__highlight">{highlight}</span>
        <span>{title.slice(idx + highlight.length)}</span>
      </>
    );
  };

  return (
    <Box
      className="qa-section-header"
      sx={{
        textAlign: align,
        ...sx,
      }}
    >
      {label && <p className="qa-section-header__label">{label}</p>}
      <h2 className="qa-section-header__title">{renderTitle()}</h2>
      {description && <p className="qa-section-header__desc">{description}</p>}
    </Box>
  );
};

export default SectionHeader;
